import React, { useState } from "react";
import New from "../common/New";
import AdForm from "../AdForm";

const AddNew = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      {showForm && (
        <AdForm
          open={showForm}
          onClose={() => setShowForm(false)}
        />
      )}

      <div className="ml-2 mb-1">
        <New handleAddNew={() => setShowForm(true)} />
      </div>
    </>
  );
};

export default AddNew;
